import { render } from "./AardVanDePlechtigheid.vue?vue&type=template&id=369e6ec0&scoped=true"
import script from "./AardVanDePlechtigheid.vue?vue&type=script&lang=js"
export * from "./AardVanDePlechtigheid.vue?vue&type=script&lang=js"

import "./AardVanDePlechtigheid.vue?vue&type=style&index=0&id=369e6ec0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-369e6ec0"]])

export default __exports__